// src/components/Loader.js
import React, { useRef, useState, useEffect } from 'react';
import { Bars } from 'react-loader-spinner';
import { getUserDetails } from '../services/UserService';

const Loader = ({ height = 80, width = 80, color = "#4fa94d", visible = true }) => {
    const [userDetails, setUserDetails] = useState({ loader: "DEFAULT" });
    useEffect(() => {
        const userDtl = getUserDetails();
        if (userDtl.user === undefined || userDtl.user === null || userDtl.user.loader === undefined || userDtl.user.loader === null) {
            userDtl["user"] = {};
            userDtl["user"]["loader"] = "DEFAULT";
        }
        setUserDetails(userDtl.user);

    }, []);

    return (
        <>
            {(userDetails['loader'] === "DEFAULT" || userDetails['loader'] === undefined) ? (
                <div
                    className="flex items-center justify-center w-full h-screen"
                    style={{ position: 'relative' }}
                >
                    <Bars
                        height={height}
                        width={width}
                        color={color}
                        ariaLabel="bars-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={visible}
                    />
                </div>
            ) : (
                <div className="spinner-container">
                    <img src='images/loading.gif' alt='GIF' />
                </div>
            )}
        </>

        // {(userDetails['loader'] === 'DEFAULT') ? (
        //     <>
        //     <div
        //         className="flex items-center justify-center w-full h-screen"
        //         style={{ position: 'relative' }}
        //     >
        //         <Bars
        //             height={height}
        //             width={width}
        //             color={color}
        //             ariaLabel="bars-loading"
        //             wrapperStyle={{}}
        //             wrapperClass=""
        //             visible={visible}
        //         />
        //     </div>
        //     </>
        // ): (
        //     null
        // )}    

    );
};

export default Loader;
